<span #trigger class="novatiq-popover__trigger cursor-pointer inline-flex">
  <ng-content></ng-content>
</span>
<p-popover
  #pPopover
  [appendTo]="appendTarget"
  [dismissable]="closeOnOutsideClick"
  [class]="popoverStyleClass"
  [style]="{ width: 'min(24rem, calc(100vw - 2rem))' }"
  (onShow)="onPrimePopoverShow()"
>
  <ng-template #content>
    <ng-container *ngTemplateOutlet="popTemplateRef" />
  </ng-template>
</p-popover>
